import { useTranslation } from "react-i18next";
import {
  FormHelperText,
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  Typography,
} from "@material-ui/core";
import { ExcludeMatching } from "@dashboard-v3/api";

type Props = {
  value?: ExcludeMatching;
  onChange: (value: ExcludeMatching) => void;
};

interface InputDataProps extends React.InputHTMLAttributes<HTMLInputElement> {
  "data-testid"?: string;
}

const OPTIONS: ExcludeMatching[] = ["ANYONE", "ALL"];

/**
 * Chooses how many recipients must match the exclusion list for the rule to be
 * skipped. Available for all rules that support email flow target
 */
export default function ExcludeMatchingSelector({ value, onChange }: Props) {
  const { t } = useTranslation("rules");

  const handleChange: RadioGroupProps["onChange"] = event => {
    onChange(event.target.value as ExcludeMatching);
  };

  return (
    <>
      <Typography style={{ fontWeight: "500" }} variant="subtitle1">
        {t("targetFilter.excludeMatching.label")}
      </Typography>
      <FormHelperText>
        {t("targetFilter.excludeMatching.description")}
      </FormHelperText>

      <RadioGroup
        value={value ?? "ANYONE"}
        onChange={handleChange}
        style={{ marginTop: ".8rem" }}
        row
      >
        {OPTIONS.map(option => (
          <FormControlLabel
            key={option}
            value={option}
            control={
              <Radio
                color="primary"
                size="small"
                inputProps={
                  {
                    "data-testid": `option_excludeMatching_${option}`,
                  } as InputDataProps
                }
              />
            }
            label={
              <Typography variant="caption" style={{ fontSize: 14 }}>
                {t(`targetFilter.excludeMatching.options.${option}`)}
              </Typography>
            }
          />
        ))}
      </RadioGroup>
    </>
  );
}
